import angular from 'angular';
import parseListView from 'App/resources/parsers/listView';

angular.module('upResources').service('ParseListView', [
	function () {
		return parseListView;
	}
]);
